export const rSpace = /\s+/;
